'use client'

import BusinessSolutionPage from '@/components/platform/v2/BusinessSolutionPage'
import { getSolution } from '@/data/solutions'

const ServicesSolution = () => (
    <BusinessSolutionPage
        config={{
            meta: getSolution('services'),
            eyebrow: 'Услуги и сервис',
            titleLines: ['Весь путь клиента —', 'от первого обращения до повторной записи'],
            lead: 'VCENTRE.ONE связывает заявки, CRM, запись, оплату, коммуникации, приложение и повторные продажи в одной системе.',
            problems: [
                { title: 'Заявки приходят отовсюду', text: 'Сайт, звонки, мессенджеры, реклама, рекомендации.' },
                { title: 'История клиента теряется', text: 'Разговор в одном месте, запись в другом, оплата в третьем.' },
                { title: 'После услуги клиент пропадает', text: 'Никто системно не возвращает его.' },
                { title: 'Менеджеры работают вручную', text: 'Напоминания, подтверждения, задачи и повторные касания.' },
            ],
            flowTitle: 'От первого контакта до следующего визита',
            flow: [
                'Сайт / приложение / звонок / офлайн',
                'Единый клиент',
                'Заявка / запись',
                'CRM + ответственный',
                'Услуга / оплата',
                'История',
                'Напоминание / предложение / повторная запись',
            ],
            flowNote: 'Неважно, откуда пришёл клиент. После первого контакта он становится частью вашей системы.',
            featuresTitle: 'Что получает бизнес',
            features: [
                { title: 'CRM и клиентская база', text: 'Вся история человека в одном профиле.' },
                { title: 'Записи и заявки', text: 'Контроль статусов и ответственных.' },
                { title: 'Приложение клиента', text: 'Запись, история, документы, бонусы, чат.' },
                { title: 'Сайт', text: 'Заявки сразу попадают в рабочий процесс.' },
                { title: 'Лояльность и рекомендации', text: 'Баллы, уровни, реферальная программа.' },
                { title: 'Автоматизация', text: 'Напоминания, задачи, уведомления, повторные касания.' },
            ],
            audience: ['Клиники', 'Салоны', 'Автосервисы', 'Консалтинг', 'Сервисные компании', 'Частные специалисты'],
        }}
    />
)

export default ServicesSolution
